import { FC, Fragment, useState } from "react";
import { DatePickerStateProvider } from "@rehookify/datepicker";
import { DPUserConfig } from "@rehookify/datepicker/dist/types/config";
import { IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DateRangeCalendar } from "./DateRangeCalendar";
import { TodayButton } from "@/components/common/date-range-picker/components/date-interval-section/range/calendar/TodayButton";

interface DateRangeSelectProps {
  minDate?: string;
  maxDate?: string;
  clickSource: string;
  highlightToday?: boolean;
  onClose(): void;
  onChange: DPUserConfig["onDatesChange"];
  selectedDates: DPUserConfig["selectedDates"];
}

export const DateRangeSelect: FC<DateRangeSelectProps> = ({
  highlightToday,
  minDate,
  maxDate,
  onChange,
  selectedDates,
  clickSource,
  onClose,
}) => {
  const [offsetDate, setOffsetDate] = useState(
    clickSource === "from" ? selectedDates.at(0) : selectedDates.at(1),
  );

  return (
    <DatePickerStateProvider
      config={{
        offsetDate,
        selectedDates,
        onDatesChange: onChange,
        calendar: { startDay: 1, mode: "fluid" },
        focusDate: new Date(),

        years: { numberOfYears: 6, mode: "exact" },
        dates: {
          mode: "range",
          selectSameDate: true,
          minDate: minDate ? new Date(minDate) : undefined,
          maxDate: maxDate ? new Date(maxDate) : new Date(),
        },
      }}
    >
      <Fragment>
        <Stack
          p={1}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="caption" fontWeight="medium">
            Select date range
          </Typography>

          <Stack direction="row" alignItems="center">
            <TodayButton
              onChange={onChange}
              setOffsetDate={setOffsetDate}
              selectedDates={selectedDates}
            />

            <IconButton onClick={onClose} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>

        <DateRangeCalendar
          setOffsetDate={setOffsetDate}
          highlightToday={highlightToday}
        />
      </Fragment>
    </DatePickerStateProvider>
  );
};
